import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { PostT } from 'types/shared/core/Post';
import { Avatar, IconButton, Stack, Typography, useTheme } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StudentsDialog from 'presenters/PersonList/StudentsDialog';
import { ExtendedPostTagWrapper } from './PostTagWrapper';
import ContentDateTime from 'presenters/common/ContentDateTime';
import { DUMMY_DATETIME } from 'constants/frontend/shared/values';

type PostHeaderPropsT = {
  post: PostT;
  perspective: 'teacherSide' | 'studentSide';
  cornerActionIcon?: React.ElementType;
  onClickPostCornerAction?: () => void; // 게시글 우상단 버튼 누름
};

const PostHeader = observer(
  ({
    post,
    perspective,
    cornerActionIcon: CornerActionIcon,
    onClickPostCornerAction,
  }: PostHeaderPropsT) => {
    const { palette } = useTheme();

    const [open, setOpen] = useState(false);

    return (
      <>
        <Stack sx={{ backgroundColor: palette.background.paper }}>
          <Stack mx={2} my={2} spacing={1.5}>
            <ExtendedPostTagWrapper post={post} />

            {/* 작성자와 작성시각 */}
            <Stack direction="row" spacing={2} alignItems="center">
              <Avatar src={post.writerProfileUrl} />
              <Stack flex={1}>
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <Typography variant="subtitle1">
                    {post.writerNickname}
                  </Typography>
                  {post.studentIdList?.length && post.studentList?.length ? (
                    <>
                      <ArrowForwardIcon
                        sx={{ color: palette.text.secondary, fontSize: '16px' }}
                      />
                      <Typography
                        variant="subtitle1"
                        onClick={() => {
                          setOpen(true);
                        }}
                      >
                        {post.studentIdList.length <= 3
                          ? post.studentList?.map((s) => s.name).join(', ')
                          : `${post.studentList[0].name} 등  ${post.studentIdList.length}명`}
                      </Typography>
                    </>
                  ) : null}
                </Stack>

                <Stack direction="row" spacing={0.5} alignItems="center">
                  <AccessTimeIcon
                    sx={{ color: palette.text.secondary, fontSize: '16px' }}
                  />
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    alignItems="center"
                  >
                    <ContentDateTime
                      date={
                        post.publishedAt || post.createdAt || DUMMY_DATETIME
                      }
                    />
                  </Typography>
                </Stack>
              </Stack>
              {/* 액션버튼 ... */}
              {CornerActionIcon && onClickPostCornerAction ? (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickPostCornerAction();
                  }}
                >
                  <CornerActionIcon />
                </IconButton>
              ) : null}
            </Stack>

            {/* 게시글이라면 제목이 있으므로 이를 보여준다. */}
            {post.title && (
              <Typography variant="subtitle1" sx={{ wordBreak: 'break-all' }}>
                {post.title}
              </Typography>
            )}
          </Stack>
        </Stack>

        {perspective === 'teacherSide' && post.studentList?.length && (
          <StudentsDialog
            title="선택된 학생"
            students={post.studentList}
            open={open}
            onClose={() => {
              console.log('onClose');
              setOpen(false);
              console.log('onClose open=', open);
            }}
          />
        )}
      </>
    );
  },
);
export default PostHeader;
